import { all, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  GET_TRANSFERRING_REQUESTS,
  GET_TRANSFERRING_REQUESTS_LIST_FAILURE,
  GET_TRANSFERRING_REQUESTS_LIST_SUCCESS,
  SEND_EXPORT_EXCEL_REQUEST,
  SEND_EXPORT_EXCEL_REQUEST_FAILURE,
  SEND_EXPORT_EXCEL_REQUEST_SUCCESS,
} from '../../modules/constants';
import { defaultApi } from '../../utils/axiosApi';

function* handleGetTransferringRequestsList({ payload }) {
  try {
    const queryParams = new URLSearchParams(payload).toString();
    const url = `/albait/item-transfers/${queryParams ? '?' + queryParams : ''
      }`;
    const response = yield defaultApi(url, 'GET', null);
    yield put({
      type: GET_TRANSFERRING_REQUESTS_LIST_SUCCESS,
      payload: response,
    });
  } catch (err) {
    yield put({
      type: GET_TRANSFERRING_REQUESTS_LIST_FAILURE,
      payload: err,
    });
  }
}

function* handleSendExportExcelRequest({ payload }) {
  let link = null;
  try {
    const type = payload.type;
    const params = payload.params;
    const baseURL = `${process.env.REACT_APP_API_URL}/api/`;
    const token = localStorage.getItem('access_token');

    const queryParams = new URLSearchParams(params).toString();
    
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const headers = { 
      'Content-Type': 'blob', 
      Authorization: `Bearer ${token}` 
    };

    const config = {
      method: 'GET',
      url: `${baseURL}albait/export/${type}/?${queryParams}`,
      responseType: 'arraybuffer',
      headers,
    };

    const response = yield axios(config);
    
    if (response.status !== 200) {
      throw new Error(`Server returned status ${response.status}`);
    }

    if (!response.data || !(response.data instanceof ArrayBuffer)) {
      throw new Error('Invalid response data format');
    }

    const outputFilename = `${type}_${new Date().toLocaleString()}.xlsx`;
    const downloadUrl = URL.createObjectURL(new Blob([response.data]));
    
    link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();

    yield put({ type: SEND_EXPORT_EXCEL_REQUEST_SUCCESS, payload: response });

  } catch (err) {
    console.error('Export request error:', err);
    
    let errorMessage = 'Export failed';
    
    if (err.response) {
      // The request was made and the server responded with a status code
      errorMessage = `Server error: ${err.response.status} - ${err.response.data?.message || 'Unknown error'}`;
    } else if (err.request) {
      // The request was made but no response was received
      errorMessage = 'No response from server';
    } else if (err.message.includes('Authentication')) {
      errorMessage = 'Authentication failed - please login again';
    }

    yield put({ 
      type: SEND_EXPORT_EXCEL_REQUEST_FAILURE, 
      payload: {
        error: errorMessage,
        details: err.message
      }
    });

    console.log('err', errorMessage);

  } finally {
    // Cleanup
    if (link) {
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }
  }
}

export default function* root() {
  yield all([
    takeLatest(
      GET_TRANSFERRING_REQUESTS,
      handleGetTransferringRequestsList,
    ),
    takeLatest(
      SEND_EXPORT_EXCEL_REQUEST,
      handleSendExportExcelRequest,
    ),
  ]);
}
